export type JobErrorCode = "TranscribeFatalErrorFileNotRecognized" | "TranscribeFatalErrorAudioNotDetected"

export const JOB_ERROR_MAP = {
  "en": {
    "TranscribeFatalErrorFileNotRecognized": "The file you uploaded was not recognized. Please upload a supported file.",
    "TranscribeFatalErrorAudioNotDetected": "Audio was not detected in the uploaded file. Please check the file, and try again.",
  },
  "ja": {
    "TranscribeFatalErrorFileNotRecognized": "アップロード頂いたファイルを展開できませんでした。動画または音声ファイルをアップロードしてください。",
    "TranscribeFatalErrorAudioNotDetected": "アップロード頂いたファイルを展開できましたが、音声は検出できませんでした。音声付きのファイルをアップロードし直してください。",
  },
}

interface JobFileMetadata {
  format: {
    duration: string
    size: string
  }
}

export interface JobKey {
  /** The User ID, formatted as USER#<UserId> */
  pk: string

  /** The Job ID (scoped to the user), formatted as JOB#<JobId> */
  sk: string
}

export interface Job extends JobKey {
  /** The name of the AWS Transcribe job */
  gsi1pk?: string

  /** The user-facing name of this job (shown in the UI) */
  job_name: string

  /** The S3 key the file has been uploaded to */
  file_key: string

  /** Language code (en-US, ja-JP, etc) */
  language_code: string

  /** ISO8601 string */
  submitted_at: string
  finished_at?: string

  error?: boolean
  error_code?: JobErrorCode

  file_metadata?: JobFileMetadata
  transcript_uri?: string
}

export const getJobId = (job: Job) => job.sk.split("#")[1]
export const getUserId = (job: Job) => job.pk.split("#")[1]

export const createJobKey = (userId: string, jobId: string) => ({
  pk: `USER#${userId}`,
  sk: `JOB#${jobId}`
} as JobKey)

export const generateJobUrl = (job: Job) => {
  return `https://${process.env.FRONTEND_DOMAIN_NAME}/transcript/jobs/${getJobId(job)}`
}

export const calculateJobPrice = (job: Job) => {
  if (!job.file_metadata) {
    return 0
  }

  const durationSeconds = Math.ceil(parseFloat(job.file_metadata.format.duration))
  const durationMinutes = Math.ceil(durationSeconds / 60.0)
  return durationMinutes * 5
}
